<script setup lang="ts">
import Lunbo from "./repeat/Lunbo.vue";
import Header from "./repeat/Header.vue";
import Navbar from "./repeat/Navbar.vue";
import Lianjie from "./repeat/Lianjie.vue";
import Scroll from "./repeat/Scroll.vue";
import Dongtu from "./repeat/Dongtu.vue";
import Mask from "./repeat/Mask.vue";
import { useRouter } from "vue-router";
import mainLogo from "./../../assets/imgs/main_logo.png";
import mainLogoEn from "./../../assets/imgs/main_logoEn.png";
import zhiliang from "./../../assets/imgs/zhiliang.png";
import zhiliangEn from "./../../assets/imgs/zhiliangEn.png";
import { useI18n } from "vue-i18n";
import { computed, ref, onMounted } from "vue";
import axios from "../../utils/axios";
const router = useRouter();

const newsList = ref([]);

const { locale } = useI18n();
const handleDropdownClick = () => {
  // 处理下拉菜单点击事件
};
const mainLogoSrc = computed(() => {
  return locale.value === "en" ? mainLogoEn : mainLogo;
});

const zhiliangSrc = computed(() => {
  return locale.value === "en" ? zhiliangEn : zhiliang;
});
onMounted(() => {
  getNewsList();
});
const getNewsList = async () => {
  try {
    const response = await axios.get("/framework/news/list", {
      params: {
        pageSize: 3,
        num: 1,
      },
    });
    newsList.value = response.records;
  } catch (error) {
    console.error("获取新闻列表失败：", error);
  }
};
// mask
</script>

<template>
  <div class="box">
    <!-- 头部 -->
    <Header></Header>
    <!-- 轮播图 -->
    <Lunbo></Lunbo>
    <!-- 页面滚动 -->
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
    <div class="q_o">
      <div class="q_o_about">
        <div class="a_t" :class="{ 'en-text': $i18n.locale === 'en' }">
          <p class="indent-text">{{ $t("system.home.a_t_o") }}</p>
          <p class="indent-text">{{ $t("system.home.a_t_t") }}</p>
          <p class="indent-text">{{ $t("system.home.a_t_p") }}</p>
          <p class="indent-text">{{ $t("system.home.a_t_q") }}</p>
        </div>
      </div>
    </div>
    <div class="q_t">
      <div class="q_t_inner">
        <div class="vika_box">
          <div>
            <!-- <RouterLink to="javascript:void(0)"> -->
            <img class="img_on" :src="mainLogoSrc" alt="" />
            <!-- </RouterLink> -->
          </div>
          <div class="v_t">
            {{ $t("system.home.v_t") }}
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <!--鼠标划入 -->
    <Mask></Mask>
    <!-- 动图 -->
    <Dongtu></Dongtu>
    <!-- mask -->
    <div class="zi_liang">
      <div class="mask">
        <img :src="zhiliangSrc" alt="图片描述" />
        <p class="m_p">
          {{ $t("system.home.m_p") }}
        </p>
      </div>
    </div>
    <div class="news-section" v-if="newsList.length > 0">
      <div class="news-container">
        <div class="news-list">
          <div v-for="news in newsList" :key="news.id" class="news-item">
            <router-link :to="`/news/newpage/${news.id}`">
              <div class="news-image">
                <img :src="news.img || '/default-news.jpg'" :alt="news.title" />
              </div>
              <div class="news-content">
                <div class="news-info">
                  <span class="news-date">{{
                    news.createTime.split(" ")[0]
                  }}</span>
                </div>
                <h3>
                  {{ $i18n.locale === "zh-cn" ? news.title : news.titleEn }}
                </h3>
              </div>
            </router-link>
          </div>
        </div>
        <router-link v-if="newsList" to="/news/new" class="more-btn">{{
          $t("system.map.more")
        }}</router-link>
      </div>
    </div>

    <!--<div class="c_p">-->
    <!--   <div class="c_p_inner">-->
    <!--     <div class="inner_box">-->
    <!--       <div class="inner_t">-->
    <!--         <RouterLink to="javascript:void(0)">-->
    <!--           <div class="nes_img">-->
    <!--             <img src="./../../assets/imgs/11.png" alt="" />-->
    <!--           </div>-->
    <!--           <div class="info">-->
    <!--             <span>{{ $t("system.home.inner_1") }}</span>-->
    <!--             <span class="text">{{ $t("system.home.jq") }}</span>-->
    <!--           </div>-->
    <!--         </RouterLink>-->
    <!--       </div>-->
    <!--       <div class="inner_t">-->
    <!--         <RouterLink to="javascript:void(0)">-->
    <!--           <div class="nes_img">-->
    <!--             <img src="./../../assets/imgs/22.png" alt="" />-->
    <!--           </div>-->
    <!--           <div class="info">-->
    <!--             <span>{{ $t("system.home.inner_2") }}</span>-->
    <!--             <span class="text">{{ $t("system.home.qj") }}</span>-->
    <!--           </div>-->
    <!--         </RouterLink>-->
    <!--       </div>-->
    <!--       <div class="inner_t">-->
    <!--         <RouterLink to="javascript:void(0)">-->
    <!--           <div class="nes_img">-->
    <!--             <img src="./../../assets/imgs/33.png" alt="" />-->
    <!--           </div>-->
    <!--           <div class="info">-->
    <!--             <span>{{ $t("system.home.inner_3") }}</span>-->
    <!--             <span class="text">{{ $t("system.home.ry") }}</span>-->
    <!--           </div>-->
    <!--         </RouterLink>-->
    <!--       </div>-->
    <!--     </div>-->

    <!--     <RouterLink to="javascript:void(0)">-->
    <!--       <div class="c_g">{{ $t("system.home.g_d") }}</div></RouterLink-->
    <!--     >-->
    <!--   </div>-->
    <!-- </div>-->
    <!-- 友情链接 -->
    <div class="you_qing">{{ $t("system.home.you_qing") }}</div>
    <!-- 链接 -->
    <Lianjie></Lianjie>
  </div>
</template>
<style lang="scss" scoped>
.q_o {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  min-height: 700px;
  // mask
  padding: 160px 0 100px;
  background-image: url("./../../assets/imgs/xldoorHead.jpg");
  background-repeat: no-repeat;
  background-size: cover; // 改用 cover 而不是 103% 100%
  background-position: center; // 添加居中定位
}
.q_o_about {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1300px;
}

.a_t {
  font-size: 20px;
  line-height: 1.62;
  width: 40%;
  text-indent: 2em;
  word-wrap: break-word; // 添加长单词换行
  word-break: break-word; // 允许在单词内换行
  white-space: pre-wrap;
  .indent-text {
    margin-bottom: 1em;
    max-width: 100%; // 确保文本不会溢出容器
  }
}
.en-text {
  font-size: 18px; // 英文状态下默认字体稍小
  line-height: 1.32;
}
.a_s {
  width: 60px;
  height: 20px;
  font-size: 16px;
  text-align: center;
  line-height: 20px;
  margin-top: 60px;
  border: 2px solid #1f5368;
  color: #1f5368;
  border-radius: 5px;
  font-weight: bold;
  transition: color 0.6s ease;
}
.a_s:hover {
  color: #fff;
  background-color: #1f5368;
}
.q_t {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 100px 0px;
  background-image: url("./../../assets/imgs/66\(1\).jpg");
  background-position: center; // 调整背景位置
  background-size: cover; // 确保背景完全覆盖
}
.q_t_inner {
  width: 100%;
  height: 375px;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
  font-size: 14px;
}
.vika_box {
  display: flex;
  flex-direction: column;
  gap: 40px; // 添加间距
  width: 45%;
  height: 100%;
  margin-left: auto;
  color: #fff;
  box-sizing: border-box;
}
.img_on {
  width: auto; // 改为自适应宽度
  height: 63px; // 调整logo高度
}
.img_tw {
  width: 484px;
  height: 60px;
}
.v_t {
  width: 100%; // 改为100%宽度
  font-size: 18px; // 增大字号
  line-height: 1.5; // 增加行高
  letter-spacing: 0.5px; // 添加字间距
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); // 添加文字阴影
}
.v_t2 {
  width: 60px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  border: 3px #fff solid;
  transition: color 0.6s ease;
}
.v_t2:hover {
  color: #1f5368;
  background-color: #fff;
}
.q_f {
  width: 100%;
  height: 500px;
  background-color: cadetblue;
}
.example-showcase .el-dropdown-link {
  cursor: pointer;
  color: #fff;
  align-items: center;
}
.x_l {
  background-color: #fff;
  width: 50px;
  text-align: center;
}
hr {
  width: 80%;
  margin: 0 auto;
}

.you_qing {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  padding: 40px 0 40px 0;
  margin-left: 120px;
}
.hidden {
  display: none;
}
.c_p {
  position: relative;
  width: 100%;
  height: 580px;
  color: #3e3a39;
  font-size: 14px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 130px 0 50px;
}
.c_p_inner {
  margin: 0 auto;
  max-width: 1200px;
  box-sizing: border-box;
  height: 418px;
  padding: 0 15px;
}
.inner_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.inner_t {
  width: 32%;
  height: 318px;
  box-sizing: border-box;
}
.inner_t:hover {
  img {
    scale: 1.1;
  }
  .text {
    color: #1f5368;
  }
}
.nes_img {
  width: 100%;
  display: block;
  padding-top: 66.67%;
  position: relative;
  overflow: hidden;
  height: 0;
}
.nes_img img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  transition: all 0.6s linear;
}
.info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 50px;
}
span,
text {
  color: #000;
}
.text {
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
}
.c_g {
  margin: 0px auto;
  margin-top: 60px;
  width: 50px;
  height: 20px;
  text-align: center;
  border-radius: 5px;
  background-color: #fff;
  color: #1f5368;
  font-weight: bold;
  line-height: 20px;
  border: 2px solid #1f5368;
}
.c_g:hover {
  background-color: #1f5368;
  color: #fff;
}
.zi_liang {
  width: 100%;
  height: 700px;
  background-image: url("./../../../public/zhiliang.png");
  padding: 80px 0 100px;
  box-sizing: border-box;
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
  transition: background-image 0.5s ease-in-out;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #37a1d4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  color: #fff;
  transition: opacity 0.5s ease-in-out;
}

.mask img {
  max-width: 75%;
  height: auto;
  margin-bottom: 20px;
}

.zi_liang:hover .mask {
  opacity: 1;
}
.m_p {
  padding-top: 20px;
  width: 70%;
  font-size: 16px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin: 0 auto;
}

.news-section {
  padding: 60px 0;
  background: #f8f8f8;
}

.news-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.news-list {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.news-item {
  transition: all 0.3s ease;
  padding: 20px;

  &:hover {
    .news-image img {
      transform: scale(1.05);
    }

    .news-more {
      color: #004080;
    }
  }

  a {
    display: block;
    text-decoration: none;
    color: inherit;
  }
}

.news-image {
  width: 375px;
  height: 220px;
  overflow: hidden;
  margin-bottom: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
}

.news-content {
  padding: 0 10px;

  h3 {
    font-size: 18px;
    color: #333;
    margin-bottom: 15px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 50px;
  }
  :hover {
    color: #004080;
  }
}

.news-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.news-date {
  font-size: 14px;
  color: #999;
}

.news-more {
  font-size: 14px;
  color: #666;
  transition: color 0.3s ease;
}

.more-btn {
  display: block;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 50px auto;
  color: #004080;
  border-radius: 20px;
  border: 2px solid #004080;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: #003366;
    transform: translateY(-2px);
    color: #fff;
  }
}
</style>
